import articlePresetBase from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetBase';
import articlePresetCard from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetCard';
import presetSellgate from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetSellgate';
import { presetGallery } from './Gallery/presetGallery';
import { presetMediaTrend } from './MediaTrend/presetMediaTrend';
import { presetPicture } from './Picture/presetPicture';
import { presetPetsProduct } from './PetsProduct/presetPetsProduct';
import articlePresetFooter from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetFooter';
import presetPetsKind from './PetsKind/presetPetsKind';
import expertQuotePreset from './ExpertQuote/presetExpertQuote';
import presetPoll from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetPoll';
import type { IArticleComponents } from '@media-ui/pypo-article/src/containers/Article/Article.types';
import type { IArticlePresetsProps } from '../Article.types';
const ArticlePresets = ({ galleryShowManager, isAsyncArticle, articleFooterConfig, }: IArticlePresetsProps) => {
    return {
        ...articlePresetBase,
        ...articlePresetCard(),
        ...presetGallery(galleryShowManager),
        ...presetPicture(galleryShowManager),
        ...presetMediaTrend(isAsyncArticle),
        ...presetPetsKind(),
        ...presetPetsProduct(),
        ...expertQuotePreset(),
        ...presetPoll(({ Component: Poll, props }) => {
            return <Poll {...props} needUpdate={isAsyncArticle}/>;
        }),
        ...(articleFooterConfig
            ? articlePresetFooter(({ Component: ArticleFooter, props }) => (<ArticleFooter {...articleFooterConfig} {...props}/>))
            : {}),
        ...presetSellgate(({ Component: Sellgate, props }) => {
            return <Sellgate {...props} needUpdate={isAsyncArticle}/>;
        }),
    } as IArticleComponents;
};
export default ArticlePresets;
